// utils/findPath.js
export default function findRoutePath(routes, currentPath) {
  if (!currentPath) {
    return [];
  }

  for (const route of routes) {
    // Check for an exact match
    if (route.href === currentPath) {
      return [route];
    }

    // Check for dynamic routes (e.g., /read/[bid])
    if (route.href && route.href.includes("[") && route.href.includes("]")) {
      const routeParts = route.href.split("/").filter(Boolean);
      const pathParts = currentPath?.split("/").filter(Boolean);

      if (routeParts.length === pathParts.length) {
        const isMatch = routeParts.every((part, index) => {
          if (!part || !pathParts?.[index]) return false;
          return (
            (part?.startsWith("[") && part?.endsWith("]")) ||
            part === pathParts[index]
          );
        });

        if (isMatch) {
          return [route];
        }
      }
    }

    // Recursively check nested routes
    if (route.routes && route.routes.length > 0) {
      const subPath = findRoutePath(route.routes, currentPath);
      if (subPath.length > 0) {
        return [route, ...subPath];
      }
    }
  }

  return [];
}
